import { Routes, Route } from 'react-router-dom';
import Role from '../modules/Common/Role/Role';
import Signup from '../modules/Common/Signup/Signup';
import Signin from '../modules/Common/Signin/Signin';
import ConsumerTerms from '../modules/Consumer/ConsumerTerms/ConsumerTerms';
import BabysitterTerms from '../modules/Babysitter/BabysitterTerms/BabysitterTerms';
import ConsumerPrivacyPolicy from '../modules/Consumer/ConsumerPrivacyPolicy/ConsumerPrivacyPolicy';
import BabysitterPrivacyPolicy from '../modules/Babysitter/BabysitterPrivacyPolicy/BabysitterPrivacyPolicy';
import CreateBabysitterProfile from '../modules/Babysitter/Createprofile/Createprofile';
import CreateConsumerProfile from '../modules/Consumer/CreateProfile/CreateProfile';
import Forgotpassword from '../modules/Common/Forgotpassword/Forgotpassword';
import Verifycode from '../modules/Common/Verifycode/Verifycode';
import Changepassword from '../modules/Common/Changepassword/Changepassword';
import BabysitterDashboard from '../modules/Babysitter/Dashboard/Dashboard';
import ConsumerDashboard from '../modules/Consumer/Dashboard/Dashboard';
import InviteBabysitter from '../modules/Consumer/InviteBabysitter/InviteBabysitter';
import SelectPlan from '../modules/Consumer/SelectPlan/SelectPlan';
import { BabysitterProtectedRoute } from './BabysitterProtectedRoute';
import ConsumerProtectedRoute from './ConsumerProtectedRoute';
import Payment from '../modules/Consumer/Payment/Payment';
import EditProfile from '../modules/Consumer/EditProfile/EditProfile';
import ResetProfilePassword from '../modules/Consumer/ResetProfilePassword/ResetProfilePassword';
import Subscription from '../modules/Consumer/Subscription/Subscription';
import HelpAndSupport from '../modules/Consumer/HelpAndSupport/HelpAndSupport';
import ChangeProfilePic from '../modules/Consumer/ChangeProfilePic/ChangeProfilePic';
import UpdateGovernmentId from '../modules/Consumer/UpdateGovernmentId/UpdateGovernmentId';
import TicketDetails from '../modules/Consumer/TicketDetails/TicketDetails';
import CreateTicket from '../modules/Consumer/CreateTicket/CreateTicket';
import ProtectedRoute from './ProtectedRoute';
import ConsumerDetails from '../modules/Babysitter/ConsumerDetails/ConsumerDetails';
import GroupsList from '../modules/Babysitter/GroupsList/GroupsList';
import NotificationsList from '../modules/Babysitter/NotificationsList/NotificationsList';
import BabysitterEditProfile from '../modules/Babysitter/BabysitterEditProfile/BabysitterEditProfile';
import BabysitterChangeProfilePic from '../modules/Babysitter/BabysitterChangeProfilePic/BabysitterChangeProfilePic';
import UpdateBusinessCard from '../modules/Babysitter/UpdateBusinessCard/UpdateBusinessCard';
import BabysitterResetProfilePassword from '../modules/Babysitter/BabysitterResetProfilePassword/BabysitterResetProfilePassword';
import BabysitterHelpAndSupport from '../modules/Babysitter/BabysitterHelpAndSupport/BabysitterHelpAndSupport';
import BabysitterCreateTicket from '../modules/Babysitter/BabysitterCreateTicket/BabysitterCreateTicket';
import BabysitterTicketDetails from '../modules/Babysitter/BabysitterTicketDetails/BabysitterTicketDetails';
import { WaitingForApproval } from '../modules/Babysitter/WaitingForApproval/WaitingForApproval';
import NotFound from '../modules/Common/NotFound/NotFound';
import AddCardDetails from '../modules/Consumer/AddCardDetails/AddCardDetails';

const Router = () => {
  return (
    <Routes>
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<Role />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/signin" element={<Signin />} />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<Role />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/signin" element={<Signin />} />
      </Route>
      <Route path="/participant/terms" element={<ConsumerTerms />} />
      <Route path="/supervisor/terms" element={<BabysitterTerms />} />
      <Route path="/participant/privacy" element={<ConsumerPrivacyPolicy />} />
      <Route path="/supervisor/privacy" element={<BabysitterPrivacyPolicy />} />
      <Route path="/forgotpassword" element={<Forgotpassword />} />

      <Route path="/verifycode" element={<Verifycode />} />
      <Route path="/changepassword" element={<Changepassword />} />
      <Route element={<BabysitterProtectedRoute />}>
        <Route
          path="/babysitter/waitingForApproval"
          element={<WaitingForApproval />}
        />
        <Route
          path="/babysitter/createProfile"
          element={<CreateBabysitterProfile />}
        />
        <Route path="/supervisor/dashboard" element={<BabysitterDashboard />} />
        <Route
          path="/supervisor/participantDetails/:id"
          element={<ConsumerDetails />}
        />
        <Route path="/supervisor/group-chat" element={<GroupsList />} />
        {/* <Route path="/supervisor/consumerDetails" element={<ConsumerDetails />} /> */}
        <Route
          path="/supervisor/notifications"
          element={<NotificationsList />}
        />
        <Route
          path="/supervisor/edit-profile"
          element={<BabysitterEditProfile />}
        />
        <Route
          path="/supervisor/change-profilepic"
          element={<BabysitterChangeProfilePic />}
        />
        <Route
          path="/supervisor/update-businesscard"
          element={<UpdateBusinessCard />}
        />
        <Route
          path="/supervisor/reset-password"
          element={<BabysitterResetProfilePassword />}
        />
        <Route
          path="/supervisor/support"
          element={<BabysitterHelpAndSupport />}
        />
        <Route
          path="/supervisor/ticket/:id"
          element={<BabysitterTicketDetails />}
        />
        <Route
          path="/supervisor/createTicket"
          element={<BabysitterCreateTicket />}
        />
        {/* <Route path="/supervisor/support" element={<}/> */}
      </Route>
      <Route element={<ConsumerProtectedRoute />}>
        <Route
          path="/participant/createProfile"
          element={<CreateConsumerProfile />}
        />
        <Route path="/participant/dashboard" element={<ConsumerDashboard />} />
        {/* <Route
          path="/participant/uploadProfilePic"
          element={<UploadProfilePic />}
        />
        <Route path="/participant/uploadGovtId" element={<UploadGovtId />} /> */}
        <Route
          path="/participant/inviteBabysitter"
          element={<InviteBabysitter />}
        />
        <Route path="/participant/editProfile" element={<EditProfile />} />
        <Route
          path="/participant/changeProfilePic"
          element={<ChangeProfilePic />}
        />
        <Route
          path="/participant/updateGovernmentId"
          element={<UpdateGovernmentId />}
        />
        <Route path="/participant/selectplan" element={<SelectPlan />} />
        <Route path="/participant/payment" element={<Payment />} />
        <Route
          path="/participant/resetPassword"
          element={<ResetProfilePassword />}
        />
        <Route path="/participant/subscription" element={<Subscription />} />
        <Route path="/participant/support" element={<HelpAndSupport />} />
        <Route path="/participant/ticket/:id" element={<TicketDetails />} />
        <Route path="/participant/changeCard" element={<AddCardDetails />} />
        <Route path="/participant/createTicket" element={<CreateTicket />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Router;
